// Entrée aux matchs à domicile, par équipe (D-106) : ce que le bureau a choisi, et rien d'autre.

export type EntryMode = 'libre' | 'payante';
export interface MatchEntry { team_id: string; names: string[]; mode: EntryMode | null; price_cents: number | null; free_members: boolean; note: string | null }

const euros = (cents: number) => (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2).replace('.', ',')) + ' €';

/** « Entrée libre », « Entrée : 5 € · gratuite pour les licenciés du club », suivie de la note du bureau ;
 *  null tant que le bureau n'a rien choisi (rien n'est affiché). */
export function entryText(e: Pick<MatchEntry, 'mode' | 'price_cents' | 'free_members' | 'note'> | null | undefined): string | null {
  if (!e?.mode) return null;
  const base = e.mode === 'payante' && e.price_cents
    ? `Entrée : ${euros(e.price_cents)}${e.free_members ? ' · gratuite pour les licenciés du club' : ''}`
    : 'Entrée libre';
  const note = e.note?.trim();
  return note ? `${base} · ${note}` : base;
}

/** Les conditions de l'équipe d'un match, par son identifiant ou par le nom affiché (« SF2 », « Seniors filles »). */
export function entryFor(list: MatchEntry[], match: { team_id?: string | null; team?: string | null }): MatchEntry | null {
  if (match.team_id) { const byId = list.find(x => x.team_id === match.team_id); if (byId) return byId; }
  const name = (match.team ?? '').trim().toLowerCase();
  return name ? list.find(x => x.names.some(n => n.trim().toLowerCase() === name)) ?? null : null;
}
